import { render, staticRenderFns } from "./sundry-payment.vue?vue&type=template&id=2ec4e428"
import script from "./sundry-payment.vue?vue&type=script&lang=js"
export * from "./sundry-payment.vue?vue&type=script&lang=js"
import style0 from "./sundry-payment.vue?vue&type=style&index=0&id=2ec4e428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports